import { Provider } from '@angular/core';
import { PurchaseOperationRepository } from '@domain/purchase-operation/repositories/purchase-operation.repository';
import { PurchaseOperationRepositoryService } from '../repositories/purchase-operation.service';

export const PurchaseOperationProvider: Provider[] = [
  {
    provide: PurchaseOperationRepository,
    useClass: PurchaseOperationRepositoryService,
  },
];
